import Controller from './analytics-controller'

export default class extends Controller {
  timers = [15, 60] // second

  handleWindowLoaded () {
    this.timers.forEach(timer => {
      setTimeout(() => {
        this.labelValue = this.categoryValue + ' ' + timer
        this.sendEvent()
      }, timer * 1000)
    })
  }
}
